/* eslint-disable lingui/no-unlocalized-strings */
import { t } from "@lingui/macro";
import { DownloadSimple } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";

import { useGrandfatherAccess } from "@/client/hooks/use-grandfather";
import { useBillingStore } from "@/client/stores/billing";

export const GrandfatherBanner = () => {
  const { isGrandfathered } = useGrandfatherAccess();
  const openPaywall = useBillingStore((s) => s.openPaywall);

  if (!isGrandfathered) return null;

  return (
    <div className="mb-4 flex flex-col gap-3 rounded-lg border border-amber-300/60 bg-amber-50 px-4 py-3 text-sm text-amber-950 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-2">
        <DownloadSimple size={18} className="mt-0.5 shrink-0" />
        <p>
          {t`You can still download and export resumes you created before paid plans returned. Editing, AI tools, and new resumes require a subscription.`}
        </p>
      </div>
      <Button
        size="sm"
        className="shrink-0"
        onClick={() =>
          openPaywall(undefined, t`Start a 3-day trial to keep building on CareerBldr.`)
        }
      >
        {t`Start 3-day trial`}
      </Button>
    </div>
  );
};
